import { ERROR_USER_DETAILS, LOGIN_SUCCESS, AUTH_ERROR, LOGOUT, USER_LOADED, USER_FAIL, LOGIN_FAIL } from './constants';
import { UserRole } from '../../helper/Utils';

const initialState = {
    token: localStorage.getItem('token'),
    isAuthenticated: null,
    loading: true,
    currentUser: {},//role: 1 
    org_role: '',
    error: '',

}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case USER_LOADED:
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                currentUser: payload,
                org_role: payload.type || payload.role
            }
        case LOGIN_SUCCESS:
            return {
                ...state,
                token: payload.token,
                isAuthenticated: true,
                loading: false, // We can set this to false now because we have the role
                currentUser: {
                    id: 1,
                    name: payload.adminID,
                    role: UserRole[payload.role]
                },
                org_role: payload.role
            }
        case ERROR_USER_DETAILS: {
            return {
                ...state,
                error: payload,
                loading: false
            }
        }
        case AUTH_ERROR:
        case LOGOUT:
        case USER_FAIL:
        case LOGIN_FAIL:
            localStorage.removeItem('token');
            global.org_role = '';
            return {
                ...state,
                token: null,
                isAuthenticated: false,
                loading: false,
                currentUser: { role: 1 },
                org_role: '',
                error: '',

            }
        default:
            return state;
    }
}